// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "23b2023c" + "." + "13da54e386393bf61590" + ".js";
};